import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Button } from "react-bootstrap";
import { EmojiFrown } from 'react-bootstrap-icons';

import NavbarComponent from '../components/NavbarComponent';


class My404 extends React.Component {

    handleClickLink = (href) => {
        this.props.history.push(href);
    }
    
    render() {
        return (
            <Container className="p-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <div className="mt-4 text-center">
                                <EmojiFrown size={64} className="mr-1 text-danger" />
                                <div className="mt-2">Oops! We can't seem to find the page you're looking for.. (404)</div>
                                {!this.props.auth.isLogin
                                    ? 
                                        <div className="mt-4"><Button variant="link" onClick={() => this.handleClickLink("/")}>Go to login page</Button></div>
                                    :
                                        <div className="mt-4"><Button variant="link" onClick={() => this.handleClickLink("/home")}>Go to home page</Button></div>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(My404));